import type { ShapeType, OriginalShape } from '../constants/calculatorRecipes'

const PI = Math.PI

export interface TargetShape {
  type: ShapeType
  diameter?: number
  sideA?: number
  sideB?: number
}

function getVolume(
  shape: OriginalShape | TargetShape,
  height: number
): number {
  switch (shape.type) {
    case 'circle': {
      const r = (shape.diameter || 0) / 2
      return PI * r * r * height
    }
    case 'square': {
      const a = shape.sideA || 0
      return a * a * height
    }
    case 'rectangle': {
      const a = shape.sideA || 0
      const b = shape.sideB || 0
      return a * b * height
    }
    default:
      return 0
  }
}

export function calculateCoefficient(
  originalShape: OriginalShape,
  originalHeight: number,
  targetShape: TargetShape,
  targetHeight: number
): number {
  const originalVolume = getVolume(originalShape, originalHeight)
  const targetVolume = getVolume(targetShape, targetHeight)

  if (originalVolume === 0) return 0
  return targetVolume / originalVolume
}

export function roundAmount(amount: number): string {
  if (amount >= 100) return Math.round(amount).toString()
  if (amount >= 10) return (Math.round(amount * 10) / 10).toString()
  return (Math.round(amount * 10) / 10).toString()
}
